import { $, $$ } from "@utils/dom";
import { on, off } from "@utils/listener";
import windmill from "@core/windmill";
import Throttle from "@utils/throttle";

import * as cart from '@vendors/shopify/theme-cart/theme-cart';

class ProductForm {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;

    this._initialized = false;

    this._addToCart = this._addToCart.bind(this);
    this._selectOption = this._selectOption.bind(this);
    this._triggerOption = this._triggerOption.bind(this);
    this._updatePrice = this._updatePrice.bind(this);
    this._incrementQty = this._incrementQty.bind(this);
    this._onError = this._onError.bind(this);
    this._verifyAvailable = this._verifyAvailable.bind(this);
    this._verifyQty = this._verifyQty.bind(this);
    this._updateWishlistId = this._updateWishlistId.bind(this);

    this._optionMouseEnter = this._optionMouseEnter.bind(this);
    this._optionMouseLeave = this._optionMouseLeave.bind(this);
    this._changeOption1Label = this._changeOption1Label.bind(this);

    this.data = null;
    this._option1Label = null;

    this.init();
  }

  init() {
    if(this._initialized) return;
    this._initialized = true;

    this.idSelect = $('select[name="id"]', this.el);

    this.options = [...$$("option", this.idSelect)];
    this.optionSelects = [ ...$$('.product-form__selectOption', this.el) ];
    this.optionRadios = [ ...$$('.product-form__radioOption', this.el) ];
    this.option1Radios = [ ...$$('.product-form-option__btn[for^="option-1"]', this.el) ];

    this.optionsArray = [];

    this.qtyInput = $('input[name="quantity"]', this.el);
    this.qtyCount = $('[data-qty-count]', this.el);
    this.cartErrorElement = $('.product-form__cartError', this.el);
    this.inventoryCount = $('[data-variant-inventory-count]', this.el);
    this.lowStockMessage = $('.product-form__lowStock', this.el);
    this.option1Label = $('[data-option1-label]', this.el);

    this.price = $('[data-product-form-price]');
    this.increments = [ ...$$('[data-increment]', this.el) ];
    this.wishlist = $('.product-wishlist');

    if(this.option1Radios && this.option1Label) {
      this._option1Label = this.option1Label.dataset.option1Label;
      this.option1Throttler = new Throttle({cb: this._changeOption1Label, delay: 100, onlyAtEnd: true});
    }

    this._selectOption();
    this._bindEvents();
  }

  destroy() {
    this._unbindEvents();
    if(this.option1Throttler) this.option1Throttler.dispose();

    this.el = null;
    this.emitter = null;

    this.optionSelects = null;
    this.optionRadios = null;
    this.option1Radios = null;


    this.idSelect = null;
    this.qtyInput = null;
    this.qtyCount = null;
    this.cartErrorElement = null;
    this.inventoryCount = null;
    this.lowStockMessage = null;
    this.option1Label = null;

    this.price = null;
    this.increments = null;
    this.wishlist = null;


    this._initialized = null;

    this._addToCart = null;
    this._selectOption = null;
    this._triggerOption = null;
    this._updatePrice = null;
    this._incrementQty = null;
    this._onError = null;
    this._verifyAvailable = null;
    this._updateWishlistId = null;

    this._optionMouseEnter = null;
    this._optionMouseLeave = null;
    this._changeOption1Label = null;
  }

  _bindEvents() {
    on(this.el, "submit", this._addToCart);
    if(this.optionSelects) on(this.optionSelects, "change", this._triggerOption);
    if(this.optionRadios) on(this.optionRadios, "change", this._triggerOption);

    if(this.option1Radios && this.option1Label) {
      on(this.option1Radios, "mouseenter", this._optionMouseEnter);
      on(this.option1Radios, "mouseleave", this._optionMouseLeave);
    }
    if(this.increments) on(this.increments, "click", this._incrementQty);
  }
  _unbindEvents() {
    off(this.el, "submit", this._addToCart);
    if(this.optionSelects) off(this.optionSelects, "change", this._triggerOption);
    if(this.optionRadios) off(this.optionRadios, "change", this._triggerOption);
    if(this.option1Radios && this.option1Label) {
      off(this.option1Radios, "mouseenter", this._optionMouseEnter);
      off(this.option1Radios, "mouseleave", this._optionMouseLeave);
    }
    if(this.increments) off(this.increments, "click", this._incrementQty);
  }

  _addToCart(event) {
    if (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    // reset elements
    this.cartErrorElement.innerHTML = ``;

    // submit
    cart.addItemFromForm(this.el).then((item) => {
      this.emitter.emit('SiteCart.update');
      this.emitter.emit("DataLayer.add_to_cart", item);
    }).catch(this._onError);
  }

  _triggerOption(event){
    if (event.currentTarget.dataset.variantRedirect) {
      this.emitter.emit('ProductForm.variantChange', event.currentTarget.dataset.variantRedirect);
    } else {
      this._selectOption();
    }
  }

  _getOptions(){
    this.optionsArray = [];

    this.optionSelects.forEach((el) => {
      this.optionsArray.push({option: el.getAttribute('name'), value: el.value});
    });

    this.optionRadios.forEach((el) => {
      if (el.checked) {
        this.optionsArray.push({option: el.getAttribute('name'), value: el.value});
      }
    });
  }

  _selectOption(){
    this._getOptions();

    this.options.forEach((el) => {
      let isOption = true;

      this.optionsArray.forEach(function (option, index) {
        if (el.attributes["data-" + option.option].value !== option.value) {
          isOption = false;
        }
      });

      if (isOption) {
        this._setOption(el);
      }
    });
  }

  _setOption(option){
    this.idSelect.value = option.value;

    this._updatePrice(option.attributes);
    this._verifyAvailable(option.attributes['data-inventory-available'].value);
    this._verifyQty(option.attributes['data-inventory-qty'].value);
    this._updateWishlistId(option.value);

    if (this.option1Label) {
      this._option1Label = option.attributes['data-option-1'].value;
      this.option1Label.setAttribute('data-option1-label', this._option1Label);
      this.option1Label.innerHTML = this._option1Label;
    }

    this._updateOption1Redirects();
  }

  _updateOption1Redirects(){
    this.optionRadios.forEach(el => {
      if (el.dataset.variantRedirect) {

        const value = el.value;
        const option = el.name;

        const optionDatas = {option: option, value: value};

        let optionsArray = [...this.optionsArray];
        let index = optionsArray.findIndex(el => el.option === option);

        if (index !== -1) {
            optionsArray[index] = optionDatas;
        }

        this.options.forEach((_el) => {
          let isOption = true;

          optionsArray.forEach(function (option, index) {
            if (_el.attributes["data-" + option.option].value !== option.value) {
              isOption = false;
            }
          });

          if (isOption) {
            el.dataset.variantRedirect = _el.value;
          }
        });

      }
    });
  }

  _optionMouseEnter(event){
    const label = event.currentTarget.getAttribute('aria-label');

    this._option1Label = label;
    this.option1Throttler.init();
  }

  _optionMouseLeave(event){
    this._option1Label = this.option1Label.dataset.option1Label;
    this.option1Throttler.init();
  }

  _changeOption1Label(){
    if (this.option1Label) this.option1Label.innerHTML = this._option1Label;
  }

  _updatePrice(attributes) {
    var newPriceMarkup = "";
    if (attributes["data-compare-at-price"]) {
      newPriceMarkup += `<del>${attributes["data-compare-at-price"].value}</del> `;
    }
    newPriceMarkup += `<span>${attributes["data-price"].value}</span>`;
    this.price.innerHTML = newPriceMarkup;
  }

  _incrementQty(event){
    if( event ){
      event.stopImmediatePropagation();
      event.preventDefault();
    }

    let quantity = parseInt(event.currentTarget.getAttribute('data-increment')) + parseInt(this.qtyInput.value);
    if(quantity < 1) quantity = 1;

    this.qtyInput.value = quantity;
    this.qtyCount.innerHTML = quantity;
  }

  _verifyAvailable(available){
    if(available === 'false') {
      this.el.classList.add('--is-soldout');
    } else {
      this.el.classList.remove('--is-soldout');
    }
  }

  _verifyQty(qty) {
    if (!this.lowStockMessage || !this.inventoryCount) return;
    const lowStockLimit = parseInt(this.lowStockMessage.dataset.lowStockLimit);

    this.inventoryCount.innerHTML = qty;
    if (parseInt(qty) > 0 && parseInt(qty) < lowStockLimit) {
      this.lowStockMessage.setAttribute('aria-hidden', false);
    } else {
      this.lowStockMessage.setAttribute('aria-hidden', true);
    }

    this.emitter.emit('SiteScroll.update');
  }

  _updateWishlistId(id){
    if (!this.wishlist) return;
    
    this.wishlist.setAttribute('data-variant-id', id);
  }

  /**
   *
   * Handles error messages from Shopify Cart API
   *
   */
  _onError(error) {
    this.cartErrorElement.innerHTML = null;
    // get error messages, if any
    error.json().then((json) => {
      if(json.description) this.cartErrorElement.innerHTML = `<p><strong>${json.message} :</strong> ${json.description}</p>`;
    });
  }

}

export default ProductForm;
